import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

import type ScheduleService from 'later/services/schedule';

export default class ListRoute extends Route {
  @service declare schedule: ScheduleService;

  activate(): void {
    this.schedule.setSideLibraryBehavior('list');
  }

  deactivate(): void {
    this.schedule.setSideLibraryBehavior(undefined);
  }
}
